import { useEffect, useState } from "react";
import { usePost } from "./api";

const useQuery = (query, args = {}, options = {}) => 
  useCommonQuery(query, args, options);

const usePagination = (query, page, pageSize, args, options = {}) => 
  useCommonQuery(query, {
    ...args,
    paginate: true,
    page: page,
    pageSize: pageSize
  }, options);

const useCount = (query, args, options = {}) => 
  useCommonQuery(query, {
    ...args,
    count: true,
  }, options);

const useCommonQuery = (query, args = {}, options = {}) => {

  const [statusReq, setStatusReq] = useState({ data: null, loading: true, error: null });
  const [call, req] = usePost("/gql", {
    onCompleted: (data) => {

      if(data && data?.data) {
        data = data?.data;
        data = data[Object.keys(data)[0]];
      }
      
      setStatusReq({ data: data, loading: false, error: null });

      if(options.onCompleted)
        options.onCompleted(data);
      
    },
    onError: (error) => {
      
      setStatusReq({ data: null, loading: false, error: error });

      if(options.onError)
        options.onError(error);

    },
  });

  const deps = [query];
  if(Object.keys(args).length > 0) deps.push(JSON.stringify(args));

  const refetch = () => {
    setStatusReq({ data: null, loading: true, error: null });
    call({ query: wrapGraphQLQuery(query, args) });
  }

  useEffect(() => {

    if(args?.cancel) {
      setStatusReq({ data: null, loading: false, error: null });
      return;
    }

    setStatusReq({ data: null, loading: true, error: null });
    call({ query: wrapGraphQLQuery(query, args) });
    
  }, deps);
  
  return { ...statusReq, refetch };

}

function wrapGraphQLQuery(raw, args = {}) {

  if(args?.cancel != null || args?.cancel == undefined)
    delete args.cancel;

  const argStr = '(' + Object.entries(args).map(([key, val]) => `${key}: ${formatGraphQLValue(val)}`).join(', ') + ')';

  const start = raw.indexOf('{');
  const query = raw.slice(0, start) + (Object.keys(args).length > 0 ? argStr : '') + ' ' + raw.slice(start);

  return `query { ${query} }`;

}

function formatGraphQLValue(val) {

  if (typeof val === 'string') return `"${val}"`;
  if (typeof val === 'boolean') return val ? 'true' : 'false';
  if (typeof val === 'number') return val;

  if (typeof val === 'object' && val !== null) {
    return `"${JSON.stringify(val).replace(/"/g, '\\"')}"`;
  }

  return null;

}


export {
  useQuery,
  usePagination,
  useCount,
}